import { SearchContext } from "../Models/SearchContext";
import { SearchContextType } from "../Constants/LayoutEnums";
import {
  SearchContextAction,
  SearchContextActionType,
  ISetSelectedSearchContextPayload
} from "../Actions/SearchContextActions";

export interface SearchContextState {
  selectedContext: SearchContext;
}

export const allContext: SearchContext = {
  type: SearchContextType.All,
  name: "All",
  uniqueId: "search_all"
};

export const topicContext: SearchContext = {
  type: SearchContextType.Topic,
  name: "Topic",
  uniqueId: "search_topic",
  itemId: "search_topic"
};

export const appContext: SearchContext = {
  type: SearchContextType.App,
  name: "App",
  uniqueId: "search_app",
  itemId: "search_app"
};

const initialSearchContextState: SearchContextState = {
  selectedContext: allContext
};

const updateObject = (oldObject: any, newValues: any) => ({ ...oldObject, ...newValues });

const searchContextReducer = (
  searchContextState: SearchContextState = initialSearchContextState,
  action: SearchContextAction
) => {
  switch (action.type) {
    case SearchContextActionType.SEARCH_CONTEXT_SET_SELECTED: {
      const payload = <ISetSelectedSearchContextPayload>action.payload;
      return updateObject(searchContextState, { selectedContext: payload.searchContext });
    }
    default:
      return searchContextState;
  }
};

export default searchContextReducer;
